import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { Button } from '../form';

const PaymentMethodSelector = ({ title, history, deleteCouponCode, forceNotChangeHistory, currentSubscription, ...props }) => {
  const [types, setTypes] = useState(null);
  const [subPaymentMethods, setSubPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  useEffect(() => {
    if (props.subPaymentMethods) {
      if (props.subPaymentMethods.length > 0) {
        const subTypes = props.subPaymentMethods.reduce((acc, spm) => {
          if (acc.find(s => s.type === spm.type)) {
            return acc;
          }
          return acc.concat(spm);
        }, []);

        setTypes(subTypes);
      } else {
        setTypes([]);
      }
    }
  }, [props.subPaymentMethods]);

  const trialInProducts = useCallback(() => {
    return props?.productsToBuy?.some((elem) => elem.trial?.amount)
  }, [props?.productsToBuy])

  const shouldShowModalDefaultPaymentMethod = (method) => {
    if (currentSubscription && method) {
      return { defaultPaymentChange: true };
    }
    return { defaultPaymentChange: false };
  }

  return (
    <div className="PaymentMethodSelector">
      {title && (
        <Row>
          <Col md={12}>
            <div className="PaymentMethodSelector__title">
              {title}
            </div>
          </Col>
        </Row>
      )}
      {(types && types.length === 0) && (
        <Col md={12} className="PaymentMethodSelector__NoPaymentMethods--contianer" style={{ textAlign: 'center' }}>
          <p className="PaymentMethodSelector__NoPaymentMethods--text">
            <FormattedMessage
              id="PaymentMethodSelector.SideComponent.noPaymentMethods"
              defaultMessage="No tiene métodos de pago disponibles."
            />
          </p>
        </Col>
      )}
      <Row className="PaymentMethodSelector__container">
        {(types && !selectedPaymentMethod) && (
          <Col md={12} className="PaymentMethodSelector__grid first">
            {types.length > 0 && types.map((type) => (
              <>
                {(!trialInProducts() || type.type !== 'TICKET') && (
                  <Button
                    key={type.type}
                    onClick={() => {
                      setSelectedPaymentMethod(type)
                      const subPaymentMethods = props.subPaymentMethods.filter(method => method.type === type.type);
                      setSubPaymentMethods(subPaymentMethods);
                    }}
                  >
                    <FormattedMessage
                      id={`PaymentMethodSelector.methods.${type.paymentMethod}.subPaymentMethod.${type.type}`}
                      defaultMessage={type.name}
                    />
                  </Button>
                )}
              </>
            ))}
          </Col>
        )}
        {(selectedPaymentMethod && subPaymentMethods) && (
          <>
            {subPaymentMethods.length > 0 && (
              <Col md={12} className="PaymentMethodSelector__logos">
                {subPaymentMethods.map((subPaymentMethod, index) => (
                  <div
                    className={`PaymentMethodSelector__image-contianer ${(subPaymentMethod.id === props.currentSubPaymentMethod?.id) ? 'selected' : ''}`}
                    key={index}
                    onClick={() => {
                      // const method is a payment Method (dlocal, amazoniap, incomm...)
                      const method = props.methods.find((method) => method.name === subPaymentMethod.paymentMethod);
                      if (method) {
                        const types = { CARD: 'card', BANK_TRANSFER: 'bank', TICKET: 'ticket' };
                        const type = types[subPaymentMethod.type];
                        !forceNotChangeHistory && history.push(`methods/${subPaymentMethod.paymentMethod}/${type}` + window.location.search,  shouldShowModalDefaultPaymentMethod(type));
                        props.setCurrentSubPaymentMethod(subPaymentMethod);
                      }
                    }}
                  >
                    <div
                      className="PaymentMethodSelector__image"
                      style={{ backgroundImage: `url(${subPaymentMethod.logo})` }}
                    />
                    <p>{subPaymentMethod.name}</p>
                  </div>
                ))}
              </Col>
            )}
          </>
        )}
      </Row>
    </div>
  )
};

PaymentMethodSelector.propTypes = {
  methods: PropTypes.array.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func
  }),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.node
  ]),
  deleteCouponCode: PropTypes.func,
  subPaymentMethods: PropTypes.array,
  currentSubPaymentMethod: PropTypes.object,
  forceNotChangeHistory: PropTypes.bool,
  setCurrentSubPaymentMethod: PropTypes.func,
  productsToBuy: PropTypes.object
};

export default PaymentMethodSelector;
